// extracted by mini-css-extract-plugin
export default {"versions":"bt_gy","newsletterSignup":"bt_gz","announcement":"bt_gB"};